var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"light",style:(_vm.getStyles)},[_c('img',{attrs:{"src":"http://resali.lititutu.cn/tuku/7c60c228cde3383c404175e9e7a3ac3c.png"}})])}
var staticRenderFns = []

export { render, staticRenderFns }